<template>
  <div>
    <!-- Card -->
    <div class="bg-white border rounded-lg shadow p-4">
      <!-- Header -->
      <div class="flex justify-between items-center mb-4">
        <div class="text-xl font-bold text-primary">Operating System Summary</div>

        <!-- Export Button -->
        <button
          class="bg-primary text-white px-4 py-2 rounded-lg shadow hover:bg-green-700 transition"
          @click="downloadCsv"
        >
          ⬇ Export CSV
        </button>
        <download-csv
          :data="exportData"
          name="os_summary.csv"
          class="hidden"
          ref="exportCsv"
        />
      </div>

      <!-- Chart -->
      <div class="px-2">
        <canvas id="os-summary-graph" class="w-full h-64"></canvas>
      </div>

      <!-- Custom Legend Badges -->
      <div class="flex flex-wrap gap-2 mt-4">
        <span
          v-for="(label, index) in chartData.labels"
          :key="index"
          class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium text-white shadow"
          :style="{ backgroundColor: chartData.datasets[0].backgroundColor[index] }"
        >
          {{ label }}: {{ chartData.datasets[0].data[index] }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import GraphQl from "../../services/graphql.service";
import moment from "moment";
import Chart from "chart.js";

export default {
  name: "OsSummary",
  props: {
    filters: Object,
  },
  data() {
    return {
      chart: null,
      chartData: {
        labels: [],
        datasets: [
          {
            label: "Connections",
            data: [],
            backgroundColor: [],
          },
        ],
      },
      exportData: [],
    };
  },
  mounted() {
    this.initChart();
    this.loadStats();
  },
  watch: {
    filters: {
      handler() {
        this.loadStats();
      },
      deep: true,
    },
  },
  methods: {
    getRandomColors(count) {
      const colors = [];
      while (colors.length < count) {
        const color =
          "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0");
        if (!colors.includes(color)) colors.push(color);
      }
      return colors;
    },
    initChart() {
      const ctx = document.getElementById("os-summary-graph");
      this.chart = new Chart(ctx, {
        type: "doughnut",
        data: this.chartData,
        options: {
          responsive: true,
          plugins: {
            legend: { display: false }, // hide default legend
            tooltip: {
              callbacks: {
                label: (tooltipItem) => {
                  let value =
                    this.chartData.datasets[0].data[tooltipItem.dataIndex] || 0;
                  let label = this.chartData.labels[tooltipItem.dataIndex] || "";
                  return `${label}: ${value.toLocaleString()} connections`;
                },
              },
            },
          },
        },
      });
    },
    loadStats() {
      let v = this.filters.venues.map((venue) => venue.id);
      let params =
        (v.length > 0 ? 'venues:["' + v.join('","') + '"], ' : "") +
        'groupBy: "os", startDate: "' +
        moment(this.filters.dateRange.startDate).format("YYYY-MM-DD 00:00:00") +
        '", endDate: "' +
        moment(this.filters.dateRange.endDate).format("YYYY-MM-DD 23:59:59") +
        '"';

      // Reset chart + export data
      this.chartData.labels = [];
      this.chartData.datasets[0].data = [];
      this.chartData.datasets[0].backgroundColor = [];
      this.exportData = [];

      GraphQl.sendRequest(
        `{aggregateDeviceSummary(${params}){footfall connections os}}`
      ).then((response) => {
        response.aggregateDeviceSummary.forEach((stat) => {
          this.chartData.labels.push(stat.os);
          this.chartData.datasets[0].data.push(stat.connections);
          this.exportData.push({
            OS: stat.os,
            Connections: stat.connections,
            Footfall: stat.footfall,
          });
        });

        this.chartData.datasets[0].backgroundColor = this.getRandomColors(
          this.chartData.datasets[0].data.length
        );

        this.chart.update();
      });
    },
    downloadCsv() {
      this.$refs.exportCsv.generate();
    },
  },
};
</script>
